/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import {UiButton} from "./UiButton";
import {UiItemView} from "../UiItemView";
import {UiDropDownButtonConfig, UiDropDownButtonSubCommandHandler, UiDropDownButtonSubEventSource} from "../../generated/UiDropDownButtonConfig";
import {TeamAppsUiContext} from "../TeamAppsUiContext";
import {UiItemViewConfig} from "../../generated/UiItemViewConfig";
import {TeamAppsUiComponentRegistry} from "../TeamAppsUiComponentRegistry";
import {UiDropDown} from "../micro-components/UiDropDown";
import {UiComponent} from "../UiComponent";
import {UiComponentConfig} from "../../generated/UiComponentConfig";

/**
 * @author Yann Massard (yamass@gmail.com)
 */

export class UiDropDownButton extends UiButton implements UiDropDownButtonSubEventSource, UiDropDownButtonSubCommandHandler {
	private dropDown: UiDropDown;
	private dropDownComponent: UiComponent<UiComponentConfig>;
	private dropDownWidth: number;

	protected initialize(config: UiDropDownButtonConfig, targetElement: Element, context: TeamAppsUiContext) {
		super.initialize(config, targetElement, context);
		this.dropDown = new UiDropDown();
		this.dropDownWidth = config.dropDownWidth;
		this.getMainDomElement()
			.addClass("UiDropDownButton dropdown-toggle")
			.off("click")
			.click(() => {
				if (!this.dropDown.isOpen) {
					this.commit(true);
					this.dropDown.open(this.getMainDomElement(), {width: this.dropDownWidth});
				}
			});
		this.setDropDownComponent(config.dropDownComponent);
	}

	setDropDownWidth(dropDownWidth: number): void {
		this.dropDownWidth = dropDownWidth;
	}

	setDropDownComponent(itemViewConfig: UiItemViewConfig): void {
		if (this.dropDownComponent) {
			this.dropDownComponent.destroy();
		}
		if (itemViewConfig != null) {
			this.dropDownComponent = this._context.createComponent(itemViewConfig);
			if (this.dropDownComponent instanceof UiItemView) {
				this.dropDownComponent.onItemClicked.addListener(eventObject => {
					this.dropDown.close();
				});
			}
			this.dropDown.setContent(this.dropDownComponent);
		}
	}

	destroy(): void {
		super.destroy();
		this.dropDown.destroy(); // destroys the dropdownComponent transitively!
	}

	public static getReadOnlyHtml(config: UiDropDownButtonConfig, value: boolean, context: TeamAppsUiContext): string {
		return UiButton.getReadOnlyHtml(config, value, context);
	}

	getDefaultValue() {
		return true;
	}

	public valuesChanged(v1: boolean, v2: boolean): boolean {
		return false;
	}
}

TeamAppsUiComponentRegistry.registerFieldClass("UiDropDownButton", UiDropDownButton);